export default "__VITE_ASSET__Dko08Y3f__"